import React from 'react';

import PersonIcon from '@mui/icons-material/Person';

import type { IPostsApiPostUserRef } from '../../../../redux/api/posts/posts-api.types';
import type { IUsersApiUserProfile } from '../../../../redux/api/users/users-api.types';
import { IUser } from '../../../../types/interfaces/user';
import AppEntityAvatar, {
  AppEntityAvatarProps,
} from '../app-entity-avatar/AppEntityAvatar';

interface AppUserAvatarProps extends AppEntityAvatarProps {
  entity?: IUser | IUsersApiUserProfile | IPostsApiPostUserRef;
}

export default function AppUserAvatar(props: AppUserAvatarProps) {
  const { entity, ...avatarProps } = props;
  const fallbackSeedName = [entity?.firstname, entity?.lastname]
    .filter(Boolean)
    .join(' ')
    .trim();

  function getName() {
    if (entity?.firstname || entity?.lastname) {
      return [entity?.firstname, entity?.lastname]
        .filter(Boolean)
        .map((i) => i![0])
        .join('');
    }
  }
  return (
    <AppEntityAvatar
      {...avatarProps}
      fallbackSeedId={entity?.id}
      fallbackSeedName={fallbackSeedName}
      directPreviewStorageLink={entity?.avatar?.directPreviewStorageLink}
      directStorageLink={entity?.avatar?.directStorageLink}
      previewStorageLink={entity?.avatar?.previewStorageLink}
      storageLink={entity?.avatar?.storageLink}>
      {getName() || <PersonIcon />}
    </AppEntityAvatar>
  );
}
